import {
  ROUTE_QUIZ_INTRO,
  ROUTE_QUIZ_BUDGET,
  ROUTE_QUIZ_BUDGET_BENEFITS,
  ROUTE_QUIZ_HELLO,
  ROUTE_QUIZ_GOALS,
  ROUTE_QUIZ_GOALS_BENEFITS,
  ROUTE_QUIZ_EATING_HABITS,
  ROUTE_QUIZ_EATING_HABITS_DIETARY_NEEDS,
  ROUTE_QUIZ_MACRO_NUTRIENT,
  ROUTE_QUIZ_MACRO_NUTRIENT_LOW_SODIUM,
  ROUTE_QUIZ_FOOD_QUALITIES,
  ROUTE_QUIZ_FOOD_FORMATS,
  ROUTE_QUIZ_CUISINES,
  ROUTE_QUIZ_FLAVORS,
  ROUTE_QUIZ_MEAT,
  ROUTE_QUIZ_SEAFOOD,
  ROUTE_QUIZ_PLANTS,
  ROUTE_QUIZ_POLARIZING,
  ROUTE_QUIZ_FOOD_PREFERENCES_INTRO,
  ROUTE_QUIZ_BREAKFAST,
  ROUTE_QUIZ_BREAKFAST_FREQUENCY,
  ROUTE_QUIZ_READY_MADE,
  ROUTE_QUIZ_SNACKS,
  ROUTE_QUIZ_SNACKS_FREQUENCY,
  ROUTE_QUIZ_SWEETS,
  ROUTE_QUIZ_SWEETS_FREQUENCY,
  ROUTE_QUIZ_LUNCH,
  ROUTE_QUIZ_LUNCH_FREQUENCY,
  ROUTE_QUIZ_DINNER,
  ROUTE_QUIZ_DINNER_FREQUENCY,
  ROUTE_QUIZ_DISH_TYPES,
} from '@hungryroot/routes';

// Re-export with original names for backward compatibility (aliases only)
export const ROUTE_MACRO_NUTRIENT = ROUTE_QUIZ_MACRO_NUTRIENT;
export const ROUTE_MACRO_NUTRIENT_LOW_SODIUM =
  ROUTE_QUIZ_MACRO_NUTRIENT_LOW_SODIUM;
export const ROUTE_FOOD_QUALITIES = ROUTE_QUIZ_FOOD_QUALITIES;
export const ROUTE_FOOD_FORMATS = ROUTE_QUIZ_FOOD_FORMATS;
export const ROUTE_CUISINES = ROUTE_QUIZ_CUISINES;
export const ROUTE_FLAVORS = ROUTE_QUIZ_FLAVORS;
export const ROUTE_MEAT = ROUTE_QUIZ_MEAT;
export const ROUTE_SEAFOOD = ROUTE_QUIZ_SEAFOOD;
export const ROUTE_PLANTS = ROUTE_QUIZ_PLANTS;
export const ROUTE_POLARIZING = ROUTE_QUIZ_POLARIZING;
export const ROUTE_FOOD_PREFERENCES_INTRO = ROUTE_QUIZ_FOOD_PREFERENCES_INTRO;
export const ROUTE_BREAKFAST = ROUTE_QUIZ_BREAKFAST;
export const ROUTE_BREAKFAST_FREQUENCY = ROUTE_QUIZ_BREAKFAST_FREQUENCY;
export const ROUTE_READY_MADE = ROUTE_QUIZ_READY_MADE;
export const ROUTE_SNACKS = ROUTE_QUIZ_SNACKS;
export const ROUTE_SNACKS_FREQUENCY = ROUTE_QUIZ_SNACKS_FREQUENCY;
export const ROUTE_SWEETS = ROUTE_QUIZ_SWEETS;
export const ROUTE_SWEETS_FREQUENCY = ROUTE_QUIZ_SWEETS_FREQUENCY;

/*
  This list represents ALL possible permutations of the quiz.

  Any route that CAN be in the quiz MUST be defined here.
  Filtering and refining the route list is handled in
  'use-quiz-routes.ts'

  DO NOT EXCLUDE ROUTES that may be filtered at runtime- eg, skip meat if vegetarian.
  That logic is handled downstream.

*/
export const ROUTE_SEQUENCES = {
  base: [
    ROUTE_QUIZ_INTRO,
    ROUTE_QUIZ_HELLO,
    ROUTE_QUIZ_GOALS,
    ROUTE_QUIZ_GOALS_BENEFITS,
    ROUTE_QUIZ_BUDGET,
    ROUTE_QUIZ_BUDGET_BENEFITS,
    ROUTE_FOOD_FORMATS,
    ROUTE_QUIZ_EATING_HABITS,
    ROUTE_QUIZ_EATING_HABITS_DIETARY_NEEDS,
    ROUTE_MACRO_NUTRIENT,
    ROUTE_MACRO_NUTRIENT_LOW_SODIUM,
    ROUTE_FOOD_QUALITIES,
    ROUTE_QUIZ_DISH_TYPES,
    ROUTE_CUISINES,
    ROUTE_FLAVORS,
    ROUTE_MEAT,
    ROUTE_SEAFOOD,
    ROUTE_PLANTS,
    ROUTE_POLARIZING,
    ROUTE_FOOD_PREFERENCES_INTRO,
    ROUTE_BREAKFAST,
    ROUTE_BREAKFAST_FREQUENCY,
    ROUTE_QUIZ_LUNCH,
    ROUTE_QUIZ_LUNCH_FREQUENCY,
    ROUTE_QUIZ_DINNER,
    ROUTE_QUIZ_DINNER_FREQUENCY,
    ROUTE_SNACKS,
    ROUTE_SNACKS_FREQUENCY,
    ROUTE_SWEETS,
    ROUTE_SWEETS_FREQUENCY,
  ],
} as const;

export const LUNCH_REFRESH_ROUTES = [
  ROUTE_QUIZ_LUNCH,
  ROUTE_QUIZ_LUNCH_FREQUENCY,
  ROUTE_QUIZ_DINNER,
  ROUTE_QUIZ_DINNER_FREQUENCY,
] as const;

const routeSequenceKeys = Object.keys(ROUTE_SEQUENCES) as Array<
  keyof typeof ROUTE_SEQUENCES
>;
export const allQuizRoutes = routeSequenceKeys.reduce((acc, key) => {
  const sequence = ROUTE_SEQUENCES[key];
  sequence.forEach((route) => {
    if (acc.indexOf(route) === -1) {
      acc.push(route);
    }
  });

  return acc;
}, [] as AllQuizRoutes[]);

export type AllQuizRoutes =
  (typeof ROUTE_SEQUENCES)[keyof typeof ROUTE_SEQUENCES][number];
export const STARTING_ROUTE = ROUTE_SEQUENCES.base[0];
export const LAST_ROUTE = ROUTE_SEQUENCES.base[ROUTE_SEQUENCES.base.length - 1];
